import { media } from 'ia-react-core';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  margin-top: 6px;
`;

export const StyledIcon = styled.svg`
    align-items: center;
`;

export const StyledTitle = styled.h3`
  text-align: center;
  font-family: Montserrat,Arial black,sans-serif;
  font-size: 24px;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 700;
`;

export const StyledParagraph = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: 17px;
  font-weight: 500;
  margin:auto;
  max-width: 100%;

  ${media.sm`
    max-width: 75%;
  `};
`;

export const StyledErrorMessage = styled.div`
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin: 0px 0px 200px 0px;
  max-width: 1500px;
  padding: 48px 16px 48px;
  box-shadow: 0 4px 16px 0 rgba(0, 38, 136, 0.08);
  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  box-sizing: border-box;
`;

export const StyledActionBar = styled.div`
  margin-top: 36px;

  > * {
  }
`;
